import styled from 'styled-components'

export const Step1SearchWrapper = styled.div`

`